import { FilterInstance, FilterKind } from '../types';

function filterInFrontend<ColKeys extends string, Row extends Record<string, any>>(
  filter: FilterInstance<ColKeys>,
  row: Row
): boolean {
  const colKey = Object.keys(filter)[0] as ColKeys;

  const stringToFind = filter[colKey].startsWith;

  if (stringToFind.length === 0) {
    return true;
  }

  // cell is null or undefined and we are looking for something
  if (row[colKey] === null || row[colKey] === undefined) {
    return false;
  }

  // TODO speak with FED about startsWith vs includes
  return row[colKey].toLowerCase().includes(stringToFind.toLowerCase());
}

export const startsWithFilter: FilterKind = {
  filterInFrontend,
};
